import type {
  InventoryItem,
  ModifiedData,
} from 'app/components/pages/Extranet/ExtranetInventory/Modern/InventoryStore';
import type {
  InventoryDateExperiences,
  InventoryExperiencesForm,
} from 'app/typings/core/extranet/inventory/form/inventoryForm';

export const mapToExperienceResponse = (
  experiences: ModifiedData
): InventoryExperiencesForm => {
  const result: InventoryExperiencesForm = {};

  Object.entries(experiences || {}).forEach(([dateKey, items]) => {
    if (!items || typeof items !== 'object') {
      return;
    }

    const dateEntry: InventoryDateExperiences = {
      experiences: {},
    };

    Object.entries(items).forEach(([itemId, itemData]) => {
      if (!itemData || typeof itemData !== 'object') {
        return;
      }

      const remainingStock = (itemData as InventoryItem).remainingStock;

      const parsed =
        remainingStock === null || remainingStock === undefined
          ? null
          : typeof remainingStock === 'number'
          ? remainingStock
          : Number(remainingStock);

      dateEntry.experiences[Number(itemId)] = { remainingStock: parsed };
    });

    if (Object.keys(dateEntry.experiences).length > 0) {
      result[dateKey] = dateEntry;
    }
  });

  return result;
};
